import { useState, useRef } from "react";
import { DIFFERENCES } from "@/data/exercises";
import { Flower2, Cat, Heart, Leaf, Bird, Bell, Apple, Check } from "lucide-react";

const ICONS = { Flower2, Cat, Heart, Leaf, Bird, Bell, Apple };

export default function Differences({ onComplete }) {
  const [found, setFound] = useState([]);
  const misses = useRef(0);
  const start = useRef(Date.now());
  const total = DIFFERENCES.spots.length;

  const tapSpot = (id, e) => {
    e.stopPropagation();
    if (found.includes(id)) return;
    const nf = [...found, id];
    setFound(nf);
    if (nf.length === total) {
      const duration = Math.round((Date.now() - start.current) / 1000);
      const acc = Math.round((total / (total + misses.current)) * 100);
      setTimeout(() => onComplete({ score: acc, accuracy: acc, duration }), 600);
    }
  };

  const missTap = () => {
    misses.current += 1;
  };

  const Panel = ({ withSpots }) => (
    <div className="relative flex-1 rounded-2xl overflow-hidden border-4 border-amber-200" onClick={missTap}>
      <img src={DIFFERENCES.image} alt="scène vintage" className="w-full h-full object-cover" draggable={false} />
      {withSpots &&
        DIFFERENCES.spots.map((s) => {
          const Icon = ICONS[s.icon];
          const isFound = found.includes(s.id);
          return (
            <button
              key={s.id}
              data-testid={`difference-spot-${s.id}`}
              onClick={(e) => tapSpot(s.id, e)}
              style={{ top: `${s.top}%`, left: `${s.left}%`, backgroundColor: isFound ? "#23739F" : s.color }}
              className="absolute w-9 h-9 sm:w-11 sm:h-11 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-white shadow-md flex items-center justify-center active:scale-90 transition-transform duration-150"
            >
              {isFound ? <Check className="w-5 h-5 text-white" strokeWidth={3} /> : <Icon className="w-5 h-5 text-white" />}
            </button>
          );
        })}
    </div>
  );

  return (
    <div className="w-full max-w-5xl mx-auto text-center" data-testid="differences-game">
      <p className="text-2xl font-patient font-bold text-gray-700 mb-2">
        Trouvez les 7 objets présents sur l'image de droite
      </p>
      <p className="text-lg font-patient text-emerald-700 font-bold mb-6">
        Trouvés : {found.length}/{total}
      </p>
      <div className="flex flex-col sm:flex-row gap-4 h-[26rem]">
        <div className="flex-1 flex flex-col">
          <span className="font-patient font-bold text-gray-500 mb-1">Image d'origine</span>
          <Panel withSpots={false} />
        </div>
        <div className="flex-1 flex flex-col">
          <span className="font-patient font-bold text-gray-500 mb-1">À observer</span>
          <Panel withSpots />
        </div>
      </div>
    </div>
  );
}
